import indexOf from "lodash/indexOf"
import { Model } from "backbone"

export default class User extends Model {
  exists() {
    return this.get("type")
  }

  isEditor() {
    return this.get("type") === "Editor"
  }

  isAuthor() {
    return this.get("type") === "Author"
  }

  isConfirmedAuthor() {
    return this.get("author_profile_state") === "confirmed_expert"
  }

  hasAccessTo(feature) {
    if (indexOf(this.get("beta_features"), feature) !== -1) {
      return true
    }
    return false
  }

  allowedToContactAuthors() {
    return this.get("allowed_to_contact_authors") || false
  }

  getProfileNotificationsUrl() {
    return `/profiles/${this.get("slug")}/notifications`
  }
}

export const wrapInUserModel = (data) => Promise.resolve(new User(data))
